import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#F0F7F4'
  }} data-id="element-117">
      <div className="max-w-4xl mx-auto px-4" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-119">
          <div className="text-center mb-10" data-id="element-120">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6" style={{
            backgroundColor: '#C9A96E',
            color: 'white'
          }} data-id="element-121">
              <SparklesIcon className="w-4 h-4" data-id="element-122" />
              El Método Único
            </span>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4" style={{
            color: '#1A1A1A'
          }} data-id="element-123">
              El Ciclado de Enzimas Locales
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border-2" style={{
          borderColor: '#C9A96E'
        }} data-id="element-124">
            <p className="text-lg md:text-xl leading-relaxed mb-6" style={{
            color: '#4A4A4A'
          }} data-id="element-125">
              <strong style={{
              color: '#1A1A1A'
            }} data-id="element-126">
                No es una dieta; es una intervención biológica de 3 días.
              </strong>
            </p>

            <p className="text-lg md:text-xl leading-relaxed mb-6" style={{
            color: '#4A4A4A'
          }} data-id="element-127">
              Utilizando alimentos específicos de nuestra región (como la{' '}
              <strong style={{
              color: '#C9A96E'
            }} data-id="element-128">
                piña
              </strong>
              , la{' '}
              <strong style={{
              color: '#C9A96E'
            }} data-id="element-129">
                auyama
              </strong>{' '}
              y el{' '}
              <strong style={{
              color: '#C9A96E'
            }} data-id="element-130">
                jengibre
              </strong>
              ) en un orden estratégico, obligamos a tu sistema digestivo a
              liberar el líquido retenido y procesar los gases acumulados.
            </p>

            <div className="bg-[#F0F7F4] rounded-2xl p-6 mt-8" data-id="element-131">
              <p className="text-xl md:text-2xl font-medium text-center" style={{
              color: '#1A1A1A',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-132">
                Es como un{' '}
                <span style={{
                color: '#C9A96E'
              }} data-id="element-133">
                  "reinicio de fábrica"
                </span>{' '}
                para tu metabolismo que activa la desinflamación desde la
                primera comida.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}